<ng-container *ngIf="licenceCountryData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="licenceCountryData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--withFlag TableTitle--withFlagAndSwitch">
    <h2 class="Country">Country</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/'>Licences</a> in {{ licenceCountryData.country.name }}</h1>
    <img *ngIf="countryData" class="Flag" [src]="getImageUrl(licenceCountryData.country.code)" alt="Flag of {{ licenceCountryData.country.name }}"/>
    <div class="Switch" (click)="toggleActiveMode()" [ngClass]="graphicMode ? 'Active' : ''" *ngIf="isGraphicDataAvailable()">
      <label for="on">
        <span data-title="Graphic"></span>
      </label>
    </div>
  </div>
  <div *ngIf="isTableMode()" class="TableMode" [class.Active]="isTableMode()">
    <ul class="Accordeon">
      <li [class.NoArrow]="hideAccordionArrow(licenceCountryData.country)" *ngIf="countryData">
        <header 
          [class.Active]="isActiveAccordion('CountryFacts')" 
          (click)="onClickAccordion('CountryFacts')"
        >
          <h2>Country facts</h2>
        </header>
        <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('CountryFacts')">
          <table class="BasicResponsiveTable">
            <thead>
              <tr>
                <th scope="col">List of operators</th>
                <th scope="col" [class.DisplayNone]="!countryData.capital">Capital</th>
                <th scope="col" [class.DisplayNone]="!countryData.area">Area (km<sup>2</sup>)</th>
                <th scope="col" [class.DisplayNone]="!countryData.population">Population</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-th="List of operators">
                  <span *ngFor="let operator of licenceCountryData.operators; last as isLast;">
                    <span style="display: inline-block;">{{ operator }}<span *ngIf="!isLast">,&nbsp;</span></span>
                  </span>
                </td>
                <td data-th="Capital" [class.DisplayNone]="!countryData.capital">
                  {{ countryData.capital }}
                </td>
                <td data-th="Area (km²)" [class.DisplayNone]="!countryData.area">
                  {{ countryData.area | number }}
                </td>
                <td data-th="Population" [class.DisplayNone]="!countryData.population">
                  <span [innerHTML]="changePopulationFormat(countryData.population)"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
      
      <li [class.DisplayNone]="hideSpectrumAuthority(licenceCountryData.country)">
        <header 
          [class.Active]="isActiveAccordion('SpectrumAuthority')" 
          (click)="onClickAccordion('SpectrumAuthority')"
        >
          <h2>Spectrum profile</h2>
        </header>
        <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('SpectrumAuthority')">
          <table class="BasicResponsiveTable">
            <thead>
              <tr>
                <th scope="col" [class.DisplayNone]="!licenceCountryData.country.authority">Authority</th>
                <th scope="col" [class.DisplayNone]="!licenceCountryData.country.legalBasis">Legal basis</th>
                <th scope="col" [class.DisplayNone]="!licenceCountryData.country.allocationTable">Allocation table</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-th="Authority" [class.DisplayNone]="!licenceCountryData.country.authority">
                  <div class="RichText" [innerHtml]="licenceCountryData.country.authority | forceTarget"></div>
                </td>
                <td data-th="Legal basis" [class.DisplayNone]="!licenceCountryData.country.legalBasis">
                  <div class="RichText" [innerHtml]="licenceCountryData.country.legalBasis | forceTarget"></div>
                </td>
                <td data-th="Allocation table" [class.DisplayNone]="!licenceCountryData.country.allocationTable">
                  <div class="RichText" [innerHtml]="licenceCountryData.country.allocationTable | forceTarget"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </li>
      
      <li [class.DisplayNone]="!licenceCountryData.country.countryOutlook">
        <header 
          [class.Active]="isActiveAccordion('CountryOutlook')" 
          (click)="onClickAccordion('CountryOutlook')"
        >
          <h2>Policy outlook</h2>
        </header>
        <div class="Accordeon-content" [class.DisplayNone]="!isActiveAccordion('CountryOutlook')">
          <div class="RichText" [innerHtml]="licenceCountryData.country.countryOutlook | forceTarget"></div>
        </div>
      </li>
    </ul>
    
    <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile" *ngIf="licenceCountryData.licences.length > 0">
      <thead>
        <tr>
          <th scope="col">Band</th>
          <th scope="col">Operators</th>
          <th scope="col">MHz</th>
          <th scope="col">Awards</th>
        </tr>
      </thead>
      <tbody *ngFor="let row of licenceCountryData.licences">
        <tr>
          <td data-th="Band" class="NoWrap">
            <a [routerLink]="'/licences/country/'+licenceCountryData.country.code+'/band/'+row.bandCode">{{ ('Band.' + row.bandCode) | translate }}</a>
          </td>
          <td data-th="Operator – MHz" class="NoWrap" [class.EmptyCell]="row.operatorBandwidths.length===0">
            <div *ngFor="let operatorBandwidth of row.operatorBandwidths" class="Loop">{{ operatorBandwidth.operator }} <span class="ShowOnlyOnMobile">– {{ operatorBandwidth.bandwidth }}</span></div>
          </td>
          <td data-th="MHz" class="NoWrap HideCellOnMobile" [class.EmptyCell]="row.operatorBandwidths.length===0">
            <div *ngFor="let operatorBandwidth of row.operatorBandwidths" class="Loop">{{ operatorBandwidth.bandwidth }}</div>
          </td>
          <td data-th="Awards" [class.EmptyCell]="row.awards.length===0">
            <span *ngFor="let award of row.awards; last as isLast;">
              <span style="display: inline-block;"><a [routerLink]="'/awards/'+award.awardKey">{{ award.awardKey | delete2FirstChar }}</a><span *ngIf="!isLast">,&nbsp;</span></span>
            </span>
          </td>
          <td data-th="Comments" class="Comment Comment--cell" [class.EmptyCell]="row.comments.length===0" [class.DisplayNone]="row.comments.length===1">
            <div *ngFor="let comment of row.comments" class="RichText" [innerHtml]="comment | forceTarget"></div>
          </td>
        </tr>
        <tr class="Comment Comment--row" *ngIf="row.comments.length > 0" [class.DisplayNone]="row.comments.length===1">
          <td colspan="4">
            <table class="BasicResponsiveTable">
              <tbody>
                <tr>
                  <td data-th="List of operators">
                    <span *ngFor="let comment of row.comments" class="RichText" [innerHtml]="comment | forceTarget"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="NoResult" *ngIf="licenceCountryData.licences.length===0 && !licenceCountryData.light">
      <p>No licence registered in the database</p>
    </div>
    <div class="NoResult" *ngIf="licenceCountryData.licences.length===0 && licenceCountryData.light">
      <p>No licence registered in the database or Upgrade your subscription</p>
    </div>
  </div>
  
  <div *ngIf="isGraphicMode()" class="GraphicMode" [class.Active]="isGraphicMode()">
    <ul class="FrequencyDistribution-list">
      <li class="FrequencyDistribution-listItem" [class.FrequencyDistribution-listItem--noGraph]="band.ranges.length===0" *ngFor="let band of licenceCountryData.frequencyDistributions.frequencyDistributionList">
        <h5>{{ ('Band.' + band.bandCode) | translate }}</h5>
        <div class="FrequencyDistribution" *ngIf="band.ranges.length > 0">
          <div class="FrequencyDistribution-container">
            <div *ngFor="let frequency of band.ranges" class="Frequency-container" [ngClass]="frequency.duplexModeWay" [ngStyle]="{'-ms-flex-preferred-size': frequency.percent+'%', 'flex-basis': frequency.percent+'%'}">
              <p class="Start">{{ frequency.start }}</p>
              <p class="End">{{ frequency.end }}</p>
              <div class="Frequency">
                <div class="Block-container">
                  <div *ngFor="let block of frequency.licences"  class="Block" [ngClass]="block.classification" [ngStyle]="{'-ms-flex-preferred-size': block.percent+'%', 'flex-basis': block.percent+'%'}">
                    <h4>{{block.size}}</h4>
                  </div>
                </div>
              </div>
              <h3 class="Title">{{ ('Frequency.' + frequency.duplexModeWay) | translate }}</h3>
            </div>
          </div>
          <ul class="Legend">
            <li *ngFor="let operator of band.legend.classification | keyvalue">
              <span [ngClass]="operator.key"></span>
              <p>{{ operator.value }}</p>
              <sup *ngIf="showAsterisk(operator, band.legend.allGroupedNames)">*</sup>
            </li>
            <legend *ngIf="band.legend.allGroupedNames">* {{ band.legend.allGroupedNames }}</legend>
          </ul>
        </div>
        <div class="FrequencyDistribution FrequencyDistribution--notAvailable" *ngIf="band.ranges.length===0 && !band.light">
          <p class="Start">{{ band.noGraphFallback.start }}</p>
          <p class="End">{{ band.noGraphFallback.end }}</p>
          <div class="FrequencyDistribution-container">
            <p *ngIf="band.noGraphFallback.percent === 0">
              <b *ngIf="band.noGraphFallback.nationalRegionalCount.regional">Regional licences -</b>
              <b *ngIf="band.noGraphFallback.nationalRegionalCount.local">Local licences -</b>
              &nbsp;The exact location of the licences within the band is not available yet.
            </p>
            <p *ngIf="band.noGraphFallback.percent > 0"><b>{{ band.noGraphFallback.percent }}% <span *ngIf="band.noGraphFallback.mhzTotalSize!='0'">({{ band.noGraphFallback.mhzTotalSize }} MHz) </span>awarded</b> - The exact location of the licences within the band is not available yet.</p>
            <span class="Progress" [style.width]="band.noGraphFallback.percent+'%'"></span>
          </div>
          <ul class="Legend Legend--noGraphFallback">
            <li *ngFor="let operator of band.noGraphFallback.operators">
              <span></span>
              <p>{{operator}}</p>
              <sup *ngIf="showAsterisk(operator, band.legend.allGroupedNames)">*</sup>
            </li>
            <legend *ngIf="band.legend.allGroupedNames">* {{ band.legend.allGroupedNames }}</legend>
          </ul>
        </div>
        <div class="NoResult NoResult--spectrumLight" *ngIf="band.ranges.length===0 && band.light">
          <p>You need to <b>upgrade your subscription</b> to see this graphic</p>
        </div>
      </li>
    </ul>
  </div>
</ng-container>